import { render, staticRenderFns } from "./verification-requests.vue?vue&type=template&id=7e18e490&"
import script from "./verification-requests.vue?vue&type=script&lang=js&"
export * from "./verification-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports